/**
 * @copyright (C) 2023-2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-12-06 18:58:06
 **/

import { Loader } from "@/frameworks/designStuff/components";

import * as S from "../../emotion";
import Layout from "../../Layout";

export default function PrepareDevice() {
	return (
		<Layout title="장치 설정">
			<S.VideoContent gap={10} horizonAlign="center">
				<S.VideoWrapper>
					<S.Video autoPlay playsInline muted />
					<Loader />
				</S.VideoWrapper>
			</S.VideoContent>
		</Layout>
	);
}
